<script setup lang="ts">
import { defineProps, computed } from 'vue'

const props = withDefaults(
  defineProps<{
    sortKey: string;
    sortType: string;
    elementKey: string
    title: string;
    titleWidth: string
    labelStyle: string;
    searchable: boolean;
    sortable: boolean;
    isAllSelected: boolean;
  }>(),
  {
    titleWidth: '100%',
    labelStyle: '',
    searchable: false,
    sortable: false,
    isAllSelected: true
  }
);

const searchStatusIcon = computed(() => () => {
  if (props.isAllSelected) {
    return 'filter_list'
  }
  return 'filter_alt'
})

const isDisplaySortIcon = computed(() => (key: string) => {
  if (props.sortKey && props.sortKey == key) {
    return 'sort'
  }
  return ''
})

const sortStatus = computed(() => () => {
  if (props.sortType == 'ASC') {
    return -1
  }
  return 1
})
</script>
<template>
  <div class="d-flex justify-content-end" :style="props.labelStyle">
    <div
      class="d-flex justify-content-between align-center"
      :style="`width: ${props.titleWidth}`"
    >
      {{ props.title }}
      <div class="mr-3">
        <span
          v-if="props.searchable"
          class="material-symbols-outlined mr-2"
        >
          {{ searchStatusIcon(props.elementKey) }}
        </span>
        <span
          v-if="props.sortable"
          class="material-symbols-outlined"
          :style="`transform: scaleY(${sortStatus()})`"
        >
          {{ isDisplaySortIcon(props.elementKey) }}
        </span>
      </div>
    </div>
  </div>
</template>
